import React, { useContext } from 'react';
import './PaiementDenied.scss';
import _ from 'lodash';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import Context from 'utils/Context';


const PaiementDenied = ({
    seance,
    onClose,
    go,
}) => {
    const { modele, appState } = useContext(Context);
    const { t } = useTranslation();

    const seanceLocal = _.find(modele.seances, { seance_id: seance.seance_id });
    const isLocal = seanceLocal && seanceLocal.local;
    return (
        <div>
            <DialogTitle>{t('acces-refuse')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('desole-cet-e-mail-nest-pas-autorise-pour-cette-seance')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button type="submit" color="primary" onClick={onClose} >
                    {t('fermer')}
                </Button>
                {appState.user.geolocOk && isLocal && seance.billetterie === 1 && (
                    <Button type="submit" color="primary" onClick={() => go(7)} >
                        {t('acheter-mon-ticket')} {seance.prix}{appState.conf.CURRENCY_SYMBOL}
                    </Button>
                )}
            </DialogActions>
        </div>
    );
};

export default PaiementDenied;
